
import { AbstractControl } from "@angular/forms"


export const isSpecialCharacters = (control: AbstractControl) : { [key: string]: any } | null => {
  const value = control.value;
  const regexSpecial = /[^\w\-\_]/
  
  if (regexSpecial.test(value)) {
    return { isSpecialCharacters: true };
  }
 
  return null
}